<script>
export default {
	props: {
		select: {
			type: String,
			default: 'projects',
			required: true,
		},
		selectOptions: {
			type: Array,
			default: () => [
				'Web Application',
				'Mobile Application',
			],
		},
	},
};
</script>

<template>
	<select
		@change="$emit('filter', $event.target.value)"
		:name="select"
		:id="select"
		class="font-sans
				px-4
				py-2
				w-full
				border border-gray-300
				dark:border-gray-700
				rounded-md
				text-sm
				bg-white
				dark:bg-black
				text-gray-900
				dark:text-gray-100
                focus:ring-1 focus:ring-gray-500 focus:border-gray-500 transition-colors
			"
	>
		<option value class="text-sm">All Projects</option>
		<option
			v-for="option in selectOptions"
			:key="option"
			:value="option"
			class="text-sm"
		>
			{{ option }}
		</option>
	</select>
</template>

<style lang="scss" scoped></style>
